angular.module('zc')
  .directive('zcDashboardChartLoader', zcDashboardChartLoader);

zcDashboardChartLoader.$inject = [
  '$compile',
];

function zcDashboardChartLoader($compile) {
  return {
    scope: {
      chart: '<',
      project: '<',
    },
    controller: function($element, $scope, $rootScope) {
      const vm = this;
      vm.$onInit = () => {
        const tag = `zc-dashboard-${$scope.chart.name}-chart`;
        const component = `<${tag}
          project="$ctrl.project"
          chart="$ctrl.chart"
        ></${tag}>`;

        const newScope = angular.extend($rootScope.$new(), {
          $ctrl: {
            project: $scope.project,
            chart: $scope.chart,
          },
        });

        $element.append($compile(component)(newScope));
      };
    },
  };
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.dashboard/dashboard_chart_loader.js